window.FoxTheme = window.FoxTheme || {};
FoxTheme.config = {
    hasLocalStorage: false,
    mqlMobile: false,
    mqlTablet: false,
    mediaQueryMobile: 'screen and (max-width: 767px)',
    mediaQueryTablet: 'screen and (max-width: 1023px)',
    motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
    isRTL: document.documentElement.getAttribute('dir') === 'rtl',
};
(function () {
    // Detect browser has support local storage.
    try {
        const key = 'sleek:test';
        window.localStorage.setItem(key, 'test');
        window.localStorage.removeItem(key);
        FoxTheme.config.hasLocalStorage = true;
    } catch (err) {
    }

    FoxTheme.DOMready = function (callback) {
        document.readyState != 'loading' ? callback() : document.addEventListener('DOMContentLoaded', callback);
    };

    FoxTheme.a11y = {
        trapFocusHandlers: {},
        getFocusableElements: (container) => {
            return Array.from(
                container.querySelectorAll(
                    "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
                )
            );
        },
        trapFocus: (container, elementToFocus = container) => {
            var elements = FoxTheme.a11y.getFocusableElements(container);
            var first = elements[0];
            var last = elements[elements.length - 1];

            FoxTheme.a11y.removeTrapFocus();

            FoxTheme.a11y.trapFocusHandlers.focusin = (event) => {
                if (event.target !== container && event.target !== last && event.target !== first) return;

                document.addEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
            };

            FoxTheme.a11y.trapFocusHandlers.focusout = function () {
                document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
            };

            FoxTheme.a11y.trapFocusHandlers.keydown = function (event) {
                if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
                // On the last focusable element and tab forward, focus the first element.
                if (event.target === last && !event.shiftKey) {
                    event.preventDefault();
                    first.focus();
                }

                //  On the first focusable element and tab backward, focus the last element.
                if ((event.target === container || event.target === first) && event.shiftKey) {
                    event.preventDefault();
                    last.focus();
                }
            };

            document.addEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
            document.addEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);

            elementToFocus.focus();

            if (
                elementToFocus.tagName === 'INPUT' &&
                ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
                elementToFocus.value
            ) {
                elementToFocus.setSelectionRange(0, elementToFocus.value.length);
            }
        },
        removeTrapFocus: (elementToFocus = null) => {
            document.removeEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);
            document.removeEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
            document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);

            if (elementToFocus) elementToFocus.focus();
        },
    };

    FoxTheme.utils = {
        throttle: (callback) => {
            let requestId = null,
                lastArgs;
            const later = (context) => () => {
                requestId = null;
                callback.apply(context, lastArgs);
            };
            const throttled = (...args) => {
                lastArgs = args;
                if (requestId === null) {
                    requestId = requestAnimationFrame(later(this));
                }
            };
            throttled.cancel = () => {
                cancelAnimationFrame(requestId);
                requestId = null;
            };
            return throttled;
        },
        setScrollbarWidth: () => {
            const scrollbarWidth = window.innerWidth - document.body.clientWidth;
            scrollbarWidth > 0 && document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
        },
        waitForEvent: (element, eventName) => {
            return new Promise((resolve) => {
                // Event handler that checks if the event target is the expected element
                const eventHandler = (event) => {
                    if (event.target === element) {
                        element.removeEventListener(eventName, eventHandler); // Clean up listener
                        resolve(event); // Resolve the promise with the event
                    }
                };

                // Attach the event handler to the element
                element.addEventListener(eventName, eventHandler);
            });
        },
        queryDomNodes: (selectors = {}, context = document) => {
            const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
                const findOne = typeof selector === 'string';
                const queryMethod = findOne ? 'querySelector' : 'querySelectorAll';
                const sl = findOne ? selector : selector[0];

                acc[name] = context && context[queryMethod](sl);
                if (!findOne && acc[name]) {
                    acc[name] = [...acc[name]];
                }
                return acc;
            }, {});
            return domNodes;
        },
        addEventDelegate: ({
                               context = document.documentElement,
                               event = 'click',
                               selector,
                               handler,
                               capture = false
                           }) => {
            const listener = function (e) {
                // loop parent nodes from the target to the delegation node
                for (let target = e.target; target && target !== this; target = target.parentNode) {
                    if (target.matches(selector)) {
                        handler.call(target, e, target);
                        break;
                    }
                }
            };
            context.addEventListener(event, listener, capture);
            return () => {
                context.removeEventListener(event, listener, capture);
            };
        },
        getSectionId: (element) => {
            if (element.hasAttribute('data-section-id')) {
                return element.dataset.sectionId;
            } else {
                if (!element.classList.contains('shopify-section')) {
                    element = element.closest('.shopify-section');
                }
                return element.id.replace('shopify-section-', '');
            }
        },
        debounce: (fn, wait) => {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn.apply(this, args), wait);
            };
        },
        fetchConfig: (type = 'json') => {
            return {
                method: 'POST',
                headers: {'Content-Type': 'application/json', Accept: `application/${type}`},
            };
        },
        /**
         * Store key-value pair with expiration time in localStorage
         * Use storage instead of cookie to make it work properly on Safari IOS (in iframe).
         */
        setStorage(key, value, expiryInDays) {
            if (!FoxTheme.config.hasLocalStorage) return;

            const now = new Date();
            const item = {
                value: value,
                expiry: now.getTime() + expiryInDays * 86400000,
            };
            window.localStorage.setItem(key, JSON.stringify(item));
        },
        getStorage(key) {
            if (!FoxTheme.config.hasLocalStorage) return null;

            const itemStr = window.localStorage.getItem(key);
            // If the item doesn't exist, return null.
            if (!itemStr) {
                return null;
            }
            const item = JSON.parse(itemStr);
            const now = new Date();
            // Compare the expiry time of the item with the current time.
            if (now.getTime() > item.expiry) {
                // If the item has expired, remove it from storage and return null.
                window.localStorage.removeItem(key);
                return null;
            }
            return item.value;
        },
        postLink: (path, options) => {
            options = options || {};
            const method = options['method'] || 'post';
            const params = options['parameters'] || {};

            const form = document.createElement('form');
            form.setAttribute('method', method);
            form.setAttribute('action', path);

            for (const key in params) {
                for (const index in params[key]) {
                    for (const key2 in params[key][index]) {
                        const hiddenField = document.createElement('input');
                        hiddenField.setAttribute('type', 'hidden');
                        hiddenField.setAttribute('name', `${key}[${index}][${key2}]`);
                        hiddenField.setAttribute('value', params[key][index][key2]);
                        form.appendChild(hiddenField);
                    }
                }
            }
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        },
        imageReady: (imageOrArray) => {
            if (!imageOrArray) {
                return Promise.resolve();
            }
            imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
            return Promise.all(
                imageOrArray.map((image) => {
                    return new Promise((resolve) => {
                        if ((image.tagName === 'IMG' && image.complete) || !image.offsetParent) {
                            resolve();
                        } else {
                            image.onload = () => resolve();
                        }
                    });
                })
            );
        },
        displayedMedia: (media) => {
            return Array.from(media).find((item) => {
                const style = window.getComputedStyle(item);
                return style.display !== 'none';
            });
        },
    };

    FoxTheme.pubsub = {
        PUB_SUB_EVENTS: {
            cartUpdate: 'cart-update',
            quantityUpdate: 'quantity-update',
            quantityRules: 'quantity-rules',
            quantityBoundries: 'quantity-boundries',
            variantChange: 'variant-change',
            cartError: 'cart-error',
            facetUpdate: 'facet-update',
            optionValueSelectionChange: 'option-value-selection-change',
        },
        subscribers: {},
        subscribe: (eventName, callback) => {
            if (FoxTheme.pubsub.subscribers[eventName] === undefined) {
                FoxTheme.pubsub.subscribers[eventName] = [];
            }

            FoxTheme.pubsub.subscribers[eventName] = [...FoxTheme.pubsub.subscribers[eventName], callback];

            return function unsubscribe() {
                FoxTheme.pubsub.subscribers[eventName] = FoxTheme.pubsub.subscribers[eventName].filter((cb) => {
                    return cb !== callback;
                });
            };
        },

        publish: (eventName, data) => {
            if (FoxTheme.pubsub.subscribers[eventName]) {
                FoxTheme.pubsub.subscribers[eventName].forEach((callback) => {
                    callback(data);
                });
            }
        },
    };

    FoxTheme.focusVisiblePolyfill = function () {
        const navKeys = [
            'ARROWUP',
            'ARROWDOWN',
            'ARROWLEFT',
            'ARROWRIGHT',
            'TAB',
            'ENTER',
            'SPACE',
            'ESCAPE',
            'HOME',
            'END',
            'PAGEUP',
            'PAGEDOWN',
        ];
        let currentFocusedElement = null;
        let mouseClick = null;

        window.addEventListener('keydown', (event) => {
            if (navKeys.includes(event.code.toUpperCase())) {
                mouseClick = false;
            }
        });

        window.addEventListener('mousedown', (event) => {
            mouseClick = true;
        });

        window.addEventListener(
            'focus',
            () => {
                if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

                if (mouseClick) return;

                currentFocusedElement = document.activeElement;
                currentFocusedElement.classList.add('focused');
            },
            true
        );
    };

    FoxTheme.Carousel = (function () {
        class Carousel {
            constructor(container, options, modules = null) {
                this.container = container;
                let defaultModules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination];
                if (modules) {
                    defaultModules = defaultModules.concat(modules);
                }
                this.options = {
                    modules: defaultModules,
                    ...options,
                };
            }

            init() {
                this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
            }
        }

        return Carousel;
    })();

    FoxTheme.delayUntilInteraction = (function () {
        class ScriptLoader {
            constructor(callback, delay = 5000) {
                this.loadScriptTimer = setTimeout(callback, delay);
                this.userInteractionEvents = [
                    'mouseover',
                    'mousemove',
                    'keydown',
                    'touchstart',
                    'touchend',
                    'touchmove',
                    'wheel',
                ];

                this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
                this.userInteractionEvents.forEach((event) => {
                    window.addEventListener(event, this.onScriptLoader, {
                        passive: !0,
                    });
                });
            }

            triggerScriptLoader(callback) {
                callback();
                clearTimeout(this.loadScriptTimer);
                this.userInteractionEvents.forEach((event) => {
                    window.removeEventListener(event, this.onScriptLoader, {
                        passive: !0,
                    });
                });
            }
        }

        return ScriptLoader;
    })();

    FoxTheme.Currency = (function () {
        const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

        function formatMoney(cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            let value = '';
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const formatString = format || moneyFormat;

            function formatWithDelimiters(number, precision, thousands, decimal) {
                thousands = thousands || ',';
                decimal = decimal || '.';

                if (isNaN(number) || number === null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                const parts = number.split('.');
                const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                const centsAmount = parts[1] ? decimal + parts[1] : '';

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
                case 'amount_with_apostrophe_separator':
                    value = formatWithDelimiters(cents, 2, "'");
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }

        function getBaseUnit(variant) {
            if (!variant) {
                return;
            }

            if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
                return;
            }

            return variant.unit_price_measurement.reference_value === 1
                ? variant.unit_price_measurement.reference_unit
                : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
        }

        return {
            formatMoney: formatMoney,
            getBaseUnit: getBaseUnit,
        };
    })();

    new FoxTheme.delayUntilInteraction(() => {
        document.body.removeAttribute('data-initializing');
    });

    FoxTheme.DOMready(FoxTheme.utils.setScrollbarWidth);
    // window.addEventListener('resize', FoxTheme.utils.throttle(FoxTheme.utils.setScrollbarWidth));

    const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
    FoxTheme.config.mqlMobile = mql.matches;
    mql.onchange = (event) => {
        if (event.matches) {
            FoxTheme.config.mqlMobile = true;
            document.dispatchEvent(new CustomEvent('matchMobile'));
        } else {
            FoxTheme.config.mqlMobile = false;
            document.dispatchEvent(new CustomEvent('unmatchMobile'));
        }
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;
    mqlTablet.onchange = (event) => {
        if (event.matches) {
            FoxTheme.config.mqlTablet = true;
            document.dispatchEvent(new CustomEvent('matchTablet'));
        } else {
            FoxTheme.config.mqlTablet = false;
            document.dispatchEvent(new CustomEvent('unmatchTablet'));
        }
    };
})();

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    FoxTheme.focusVisiblePolyfill();
}

let urlOfThePage = new URL(window.location.href);
if (urlOfThePage.searchParams.has('sc')) {
    setTimeout(function () {
        scrollToElement("#" + urlOfThePage.searchParams.get('sc'),false,120);
    }, 750)
}

function scrollToElement(target,highlight= false, minus = 100) {
    const element = document.querySelector(target);
    if (element) {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - minus;

        window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
        });
        if(highlight) {
            const section = document.querySelector(target);
            setTimeout(() => {
                section.classList.add('highlight-section');
                setTimeout(() => {
                    section.classList.remove('highlight-section');
                }, 1500);
            }, 100);
        }
    } else {
        // console.warn(`Element not found: ${target}`);
    }
}
function isValidEmail(email) {
    const regex = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;

    if (!regex.test(email)) return false;

    const parts = email.split('@');
    if (parts.length !== 2) return false;

    const domainParts = parts[1].split('.');
    if (domainParts.length < 2) return false; // Needs at least one dot after '@'

    if (domainParts[domainParts.length - 1].length < 2) return false;

    return true;
}
function showToast(message,type,link = "",link_text= "") {
    // Create a completely new toast for this message
    if(document.getElementById("toast-item")) document.getElementById("toast-item").remove()
    const newToast = document.createElement('div');
    newToast.className = 'dynamic-toast';
    // Add the toast to the warranty form container if it exists, otherwise to body
    document.body.appendChild(newToast);
    let bgColor = "#fff"
    let colorItem = "#000"
    let icon = `<svg class="icon icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path fill="${colorItem}" stroke="#fff" d="M16.136 6.979h0l.003-.004a1.499 1.499 0 00-2.275-1.954l-5.945 6.777-1.858-1.859A1.499 1.499 0 103.94 12.06l2.999 3s0 0 0 0c.289.29.675.44 1.1.439h.019a1.5 1.5 0 001.08-.522l6.998-7.998z"/>
                        </svg>`
    if(type === "error"){
        bgColor = "#fff"
        colorItem = "#a60f00"
        icon = '<svg class="icon icon-tick" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"/></svg>'
    }
    newToast.id = "toast-item";
    let link_section = ""
    if(link !== "" && link_text !== "" ){
           link_section = `<div><a href="${link}" class="reversed-link btn btn--underline text-sm">${link_text}</a></div>`
    }
    // Set content
    newToast.innerHTML = `
            ${icon}
            <div class="toast-text font-bold ">${message} <br/> ${link_section}</div>
        `;
    // Fix styling issues that might be causing visibility problems
    newToast.style.cssText = `
            position: fixed;
            top: 40px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 99999;
            display: flex;
            opacity: 0;
            visibility: visible;
            transition: transform 0.5s ease, opacity 0.5s ease;
            border: 1px solid #f2f2f2;
            box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
            border-radius: 4px;
            background-color: #fff;
            max-width: 90%;
            width: auto;
        `;

    // Style the toast text
    const textElement = newToast.querySelector('.toast-text');
    if (textElement) {
        textElement.style.cssText = `
                padding: 15px 20px;
                background-color: ${bgColor};
                color: #000;
                border-radius: 0 4px 4px 0;
                width: max-content;
                font-size: 16px;
                font-weight: 500;
            `;
        if(window.innerWidth < 430){
            textElement.style.cssText = `
                padding: 15px 20px;
                background-color: ${bgColor};
                color: #000;
                border-radius: 0 4px 4px 0;
                width: max-content;
                font-size: 14px;
                font-weight: 500;
            `;
        }
    }

    // Style the icon
    const iconElement = newToast.querySelector('.icon');
    if (iconElement) {
        iconElement.style.cssText = `
                width: 55px;
                ${link_section === "" ? "height: 100%;" : "height:90px;"}
                padding: 10px;
                background-color: #fff;
                ${link_section === "" ? "box-shadow: 0px 4px 10px rgb(19 152 128 / 30%);" : ""}
                border-radius: 4px 0 0 4px;
                display: flex;
                align-items: center;
                justify-content: center;
            `;
    }

    // Force the toast to be visible
    setTimeout(() => {
        newToast.style.opacity = '1';
        newToast.style.transform = 'translate(-50%, 75px)';
    }, 10);

    // Hide toast after 3 seconds
    setTimeout(() => {
        newToast.style.opacity = '0';
        setTimeout(() => {
            newToast.remove();
        }, 500);
    }, 2500);
}
function scrollToElementOffset(target, offset) {

    const element = document.querySelector(target);
    if (element) {
        const elementPosition = element.getBoundingClientRect().top + offset;
        window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
        });
    } else {

    }
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

class HTMLUpdateUtility {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        if (!oldNode || !newContent) return;
        preProcessCallbacks?.forEach((callback) => callback(newContent));

        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;

        // dedupe IDs
        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });

        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';

        postProcessCallbacks?.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 500);
    }

    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
    }
}

class PageTransition extends HTMLElement {
    constructor() {
        super();

        window.addEventListener('beforeunload', () => {
            document.body.classList.add('page-loading');
        });

        window.addEventListener('DOMContentLoaded', () => {
            FoxTheme.Motion.animate(this, {visibility: 'hidden', opacity: 0}, {duration: 1});

            document.body.classList.add('page-loaded');
            document.dispatchEvent(new CustomEvent('page:loaded'));
        });

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                document.body.classList.remove('page-loading');
            }
        });
    }
}

customElements.define('page-transition', PageTransition);

const clearModalComponentCount = new WeakMap();

class ModalComponent extends HTMLElement {
    constructor() {
        super();
        this.events = {
            handleAfterHide: 'modal:handleAfterHide',
            handleAfterShow: 'modal:handleAfterShow',
        };

        this.classes = {
            show: 'modal-show',
            showing: 'modal-showing',
        };
    }

    static get observedAttributes() {
        return ['id', 'open'];
    }

    get isLockingNeeded() {
        return false;
    }

    get requiresBodyAppended() {
        return false;
    }

    get controls() {
        return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
    }

    get designMode() {
        return this.hasAttribute('shopify-design-mode');
    }

    get open() {
        return this.hasAttribute('open');
    }

    get overlay() {
        // Check if the _overlay property is already set
        if (!this._overlay) {
            // If not set, find the element and cache it
            this._overlay = this.querySelector('.fixed-overlay');
        }

        // Return the cached element
        return this._overlay;
    }

    get focusElement() {
        return this.querySelector('button');
    }

    connectedCallback() {
        // Initialize the AbortController
        this.abortController = new AbortController();

        // Add click event listeners to all controls
        this.controls.forEach((button) => {
            button.addEventListener('click', this.onButtonClick.bind(this), {
                signal: this.abortController.signal,
            });
        });

        // Add keyup event listener to document for handling the Escape key
        document.addEventListener(
            'keyup',
            (event) => {
                if (event.code === 'Escape') {
                    this.hide();
                }
            },
            {signal: this.abortController.signal}
        );

        // Additional setup for Shopify design mode
        if (this.designMode && Shopify.designMode) {
            const section = this.closest('.shopify-section');
            section.addEventListener(
                'shopify:section:select',
                (event) => {
                    this.show(null, !event.detail.load);
                },
                {
                    signal: this.abortController.signal,
                }
            );
            section.addEventListener(
                'shopify:section:deselect',
                () => {
                    this.hide();
                },
                {
                    signal: this.abortController.signal,
                }
            );
        }
    }

    disconnectedCallback() {
        this.abortController.abort();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'open':
                this.controls.forEach((button) => button.setAttribute('aria-expanded', newValue === null ? 'false' : 'true'));

                if (oldValue === null && (newValue === '' || newValue === 'immediate')) {
                    this.hidden = false;
                    this.removeAttribute('inert');

                    this.parentElementBeforeAppend = null;
                    if (this.requiresBodyAppended && this.parentElement !== document.body) {
                        this.parentElementBeforeAppend = this.parentElement;
                        document.body.append(this);
                    }
                    const handleShowTransitionPromise = this.handleShowTransition(newValue !== 'immediate') || Promise.resolve();
                    handleShowTransitionPromise.then(() => {
                        this.handleAfterShow();
                        this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, {bubbles: true}));
                    });
                } else if (oldValue !== null && newValue === null) {
                    this.setAttribute('inert', '');

                    const handleHideTransitionPromise = this.handleHideTransition() || Promise.resolve();
                    handleHideTransitionPromise.then(() => {
                        this.handleAfterHide();

                        if (!this.hasAttribute('inert')) return;

                        if (this.parentElement === document.body && this.parentElementBeforeAppend) {
                            this.parentElementBeforeAppend.appendChild(this);
                            this.parentElementBeforeAppend = null;
                        }
                        this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, {bubbles: true}));

                        this.hidden = true;
                    });
                }
                this.dispatchEvent(new CustomEvent('toggle', {bubbles: true}));

                break;
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        if (this.open) {
            this.hide();
        } else {
            this.show(event.currentTarget);
        }
    }

    hide() {
        if (this.open) {
            this.removeAttribute('open');
            return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
        }
    }

    show(activeElement = null, animate = true) {
        if (!this.shouleBeShow()) {
            return;
        }

        if (!this.open) {
            this.prepareToShow();
            this.activeElement = activeElement;
            this.setAttribute('open', animate ? '' : 'immediate');

            if (this.isLockingNeeded) {
                document.body.classList.add(this.classes.showing);
            }

            return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
        }
    }

    handleAfterHide() {
        setTimeout(() => {
            // Remove trap focus from the active element
            FoxTheme.a11y.removeTrapFocus(this.activeElement);

            // Conditionally manage locking behavior
            if (this.isLockingNeeded) {
                // Decrement the lock layer count for the ModalElement
                const currentModalCount = clearModalComponentCount.get(ModalComponent) - 1;
                clearModalComponentCount.set(ModalComponent, currentModalCount);

                // Toggle the 'open' class on the body based on the current lock count
                document.body.classList.toggle(this.classes.show, currentModalCount > 0);
            }
        });
    }

    handleAfterShow() {
        // Trap focus on the specified elements
        FoxTheme.a11y.trapFocus(this, this.focusElement);

        // Check if locking is needed
        if (this.isLockingNeeded) {
            // Increment the lock layer count for the ModalElement
            const currentLockCount = clearModalComponentCount.get(ModalComponent) + 1;
            clearModalComponentCount.set(ModalComponent, currentLockCount);

            // Manage class changes on the document body
            document.body.classList.remove(this.classes.showing);
            document.body.classList.add(this.classes.show);
        }
    }

    shouleBeShow() {
        return true;
    }

    prepareToShow() {
    }

    handleShowTransition() {
        // Start a timeout to set an attribute
        setTimeout(() => {
            this.setAttribute('active', '');
        }, 75);

        // Return a promise that resolves when the transition ends
        return new Promise((resolve) => {
            this.overlay.addEventListener('transitionend', resolve, {once: true});
        });
    }

    handleHideTransition() {
        // Immediately remove the 'active' attribute
        this.removeAttribute('active');

        // Return a promise that resolves when the transition ends
        return new Promise((resolve) => {
            this.overlay.addEventListener('transitionend', resolve, {once: true});
        });
    }
}

customElements.define('modal-component', ModalComponent);
clearModalComponentCount.set(ModalComponent, 0);

class BasicModal extends ModalComponent {
    constructor() {
        super();
    }

    get isLockingNeeded() {
        return true;
    }

    get requiresBodyAppended() {
        return true;
    }
}

customElements.define('basic-modal', BasicModal);

/**
 * <image-preview-modal> — modern, reusable, full-screen image lightbox.
 *
 * Programmatic API:
 *   ImagePreviewModal.open(src, { alt, caption })
 *   ImagePreviewModal.openFromImg(imgEl)
 *
 * Declarative API: any element with [data-image-preview] auto-opens on click.
 *   <img data-image-preview src="..." alt="...">
 *   <a data-image-preview href="full.jpg" data-caption="My caption"><img src="thumb.jpg"></a>
 */
class ImagePreviewModal extends ModalComponent {
    constructor() {
        super();
    }

    get isLockingNeeded() { return true; }
    get requiresBodyAppended() { return true; }

    connectedCallback() {
        if (!this.querySelector('.image-preview__inner')) {
            this.innerHTML = `
                <div class="fixed-overlay image-preview__overlay" aria-controls="${this.id}"></div>
                <div class="image-preview__inner" role="dialog" aria-modal="true" aria-label="Image preview">
                    <button type="button" class="image-preview__close" aria-controls="${this.id}" aria-label="Close">
                        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
                            <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                    <figure class="image-preview__figure">
                        <img class="image-preview__img" alt="" />
                        <figcaption class="image-preview__caption" hidden></figcaption>
                    </figure>
                </div>
            `;
        }
        super.connectedCallback();
    }

    setImage(src, { alt = '', caption = '' } = {}) {
        const img = this.querySelector('.image-preview__img');
        const cap = this.querySelector('.image-preview__caption');
        if (img) { img.src = src; img.alt = alt; }
        if (cap) {
            cap.textContent = caption || '';
            cap.hidden = !caption;
        }
    }

    static getInstance() {
        let el = document.getElementById('image-preview-modal');
        if (!el) {
            el = document.createElement('image-preview-modal');
            el.id = 'image-preview-modal';
            el.className = 'modal image-preview-modal';
            el.hidden = true;
            document.body.appendChild(el);
        }
        return el;
    }

    static open(src, opts = {}) {
        const el = ImagePreviewModal.getInstance();
        el.setImage(src, opts);
        el.show();
        return el;
    }

    static openFromImg(imgEl) {
        if (!imgEl) return;
        const src = imgEl.getAttribute('data-full') || imgEl.currentSrc || imgEl.src;
        ImagePreviewModal.open(src, {
            alt: imgEl.alt || '',
            caption: imgEl.getAttribute('data-caption') || '',
        });
    }
}

customElements.define('image-preview-modal', ImagePreviewModal);

document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-image-preview]');
    if (!trigger) return;
    e.preventDefault();

    let src = trigger.getAttribute('data-full');
    if (!src) {
        if (trigger.tagName === 'IMG') {
            src = trigger.currentSrc || trigger.src;
        } else if (trigger.tagName === 'A') {
            src = trigger.getAttribute('href');
        } else {
            const innerImg = trigger.querySelector('img');
            if (innerImg) src = innerImg.currentSrc || innerImg.src;
        }
    }
    if (!src) return;

    ImagePreviewModal.open(src, {
        alt: trigger.getAttribute('data-alt') || trigger.getAttribute('alt') || (trigger.querySelector('img')?.alt ?? ''),
        caption: trigger.getAttribute('data-caption') || '',
    });
});

class TeaserModal extends ModalComponent {
    constructor() {
        super();
    }

    get isLockingNeeded() {
        return true;
    }

    get requiresBodyAppended() {
        return true;
    }
}

customElements.define('teaser-modal', TeaserModal);


class DrawerComponent extends ModalComponent {
    constructor() {
        super();
        this.events = {
            handleAfterHide: 'drawer:handleAfterHide',
            handleAfterShow: 'drawer:handleAfterShow',
        };
    }

    get isLockingNeeded() {
        return true;
    }

    get requiresBodyAppended() {
        return true;
    }
}

customElements.define('drawer-component', DrawerComponent);

class AccordionDetails extends HTMLDetailsElement {
    constructor() {
        super();
        this.initAccordion();
    }

    initAccordion() {
        this.isOpen = this.hasAttribute('open');
        this.summaryElement = this.querySelector('summary');
        this.contentElement = this.querySelector('summary + *');
        this.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

        this.summaryElement.addEventListener('click', this.toggleAccordion.bind(this));

        if (Shopify.designMode) {
            this.designModeEventSetup();
        }
    }

    static get observedAttributes() {
        return ['open'];
    }

    get open() {
        return this.isOpen;
    }

    set open(value) {
        if (value !== this.isOpen) {
            this.isOpen = value;

            if (this.isConnected) {
                this.animateAccordion(value);
            } else {
                if (value) {
                    this.setAttribute('open', '');
                } else {
                    this.removeAttribute('open');
                }
            }

            this.setAttribute('aria-expanded', value ? 'true' : 'false');
            this.setAttribute('aria-controls', this.contentElement.id);

            this.handleAfterToggle();
        }
    }

    handleAfterToggle() {
    }

    toggleAccordion(event) {
        event.preventDefault();
        this.open = !this.open;
    }

    close() {
        this.isOpen = false;
        this.animateAccordion(false);
    }

    async animateAccordion(isOpen) {
        this.style.overflow = 'hidden';

        if (isOpen) {
            this.setAttribute('open', '');

            await FoxTheme.Motion.timeline([
                [
                    this,
                    {height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`]},
                    {duration: 0.25, easing: 'ease'},
                ],
                [
                    this.contentElement,
                    {opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)']},
                    {duration: 0.15, at: '<'},
                ],
            ]).finished;
        } else {
            await FoxTheme.Motion.timeline([
                [this.contentElement, {opacity: 0}, {duration: 0.15}],
                [
                    this,
                    {height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`]},
                    {duration: 0.25, at: '<', easing: 'ease'},
                ],
            ]).finished;

            this.removeAttribute('open');
        }

        this.style.height = 'auto';
        this.style.overflow = 'visible';
    }

    designModeEventSetup() {
        this.addEventListener('shopify:block:select', () => {
            this.open = true;
        });

        this.addEventListener('shopify:block:deselect', () => {
            this.open = false;
        });
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'open') {
            this.setAttribute('aria-controls', this.contentElement.id);
        }
    }
}

customElements.define('accordion-details', AccordionDetails, {extends: 'details'});

class AccordionGroup extends AccordionDetails {
    constructor() {
        super();
    }

    handleAfterToggle() {
        if (this.isOpen) {
            const parent = this.closest('.accordion-parent') || document;
            const siblingsAccordions = parent.querySelectorAll('details[is="accordion-group"]');

            siblingsAccordions.forEach((details) => {
                if (details !== this) {
                    details.open = false;
                }
            });
        }
    }
}

customElements.define('accordion-group', AccordionGroup, {extends: 'details'});

class ProgressBar extends HTMLElement {
    constructor() {
        super();

        if (this.hasAttribute('style')) return;

        if (this.dataset.from) {
            this.initProgress();
        }

        FoxTheme.Motion.inView(this, this.init.bind(this));
    }

    init() {
        this.setPercentage(this.dataset.value, this.dataset.max);
    }

    initProgress() {
        this.setPercentage(this.dataset.from, this.dataset.max);
    }

    setPercentage(val1, val2) {
        this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
    }
}

customElements.define('progress-bar', ProgressBar);

class CartCount extends HTMLElement {
    constructor() {
        super();
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.onCartUpdate.bind(this)
        );
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    get itemCount() {
        return parseInt(this.innerText);
    }

    onCartUpdate(event) {
        if (event.cart.errors) return;

        if (event.cart.item_count > 99) {
            this.innerHTML = `<span class="text-sm">99+</span>`;
            this.classList.add('cart-count--small-medium');
        } else {
            this.innerText = event.cart.item_count;
            this.classList.remove('cart-count--small-medium');
        }
        this.hidden = this.itemCount === 0;

        const method = this.itemCount === 0 ? 'remove' : 'add';
        document.documentElement.classList[method]('cart-has-items');
    }
}

customElements.define('cart-count', CartCount);

class QuantityInput extends HTMLElement {
    quantityUpdateUnsubscriber = undefined;
    quantityBoundriesUnsubscriber = undefined;
    quantityRulesUnsubscriber = undefined;

    constructor() {
        super();
    }

    get sectionId() {
        return this.getAttribute('data-section-id');
    }

    get productId() {
        return this.getAttribute('data-product-id');
    }

    get input() {
        return this.querySelector('input');
    }

    get value() {
        return this.input.value;
    }

    connectedCallback() {
        this.abortController = new AbortController();

        this.buttons = Array.from(this.querySelectorAll('button'));
        this.changeEvent = new Event('change', {bubbles: true});

        this.input.addEventListener('input', this.onInputChange.bind(this));
        this.input.addEventListener('focus', () => setTimeout(() => this.input.select()));

        this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)), {
            signal: this.abortController.signal,
        });

        this.validateQtyRules();

        this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
            this.validateQtyRules.bind(this)
        );
        this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
            this.setQuantityBoundries.bind(this)
        );
        this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules,
            this.updateQuantityRules.bind(this)
        );
    }

    disconnectedCallback() {
        this.abortController.abort();

        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
        if (this.quantityBoundriesUnsubscriber) {
            this.quantityBoundriesUnsubscriber();
        }
        if (this.quantityRulesUnsubscriber) {
            this.quantityRulesUnsubscriber();
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.currentTarget.name === 'plus') {
            if (parseInt(this.input.getAttribute('data-min')) > parseInt(this.input.step) && this.input.value == 0) {
                this.input.value = this.input.getAttribute('data-min');
            } else {
                this.input.stepUp();
            }
        } else {
            this.input.stepDown();
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
            this.input.value = parseInt(this.input.min);
        }
    }

    onInputChange() {
        if (this.input.value === '') {
            this.input.value = parseInt(this.input.min);
        }

        const value = parseInt(this.input.value);
        const max = this.input.hasAttribute('max') ? parseInt(this.input.max) : null;
        const productForm = this.closest('.product-form');
        const errorWrapper = productForm?.querySelector('.product-form__error-message-wrapper');
        const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
        const submitButton = productForm?.querySelector('[name="add"]');

        let message = '';
        if (max !== null && value > max) {
            const cartQty = this.input.hasAttribute('data-cart-quantity')
                ? parseInt(this.input.getAttribute('data-cart-quantity'))
                : 0;
            const dataMaxAttr = this.input.hasAttribute('data-max')
                ? parseInt(this.input.getAttribute('data-max'))
                : null;
            const totalCap = dataMaxAttr !== null ? dataMaxAttr : (max !== null ? max + cartQty : null);
            if (totalCap !== null) {
                if (cartQty > 0) {
                    // max is remaining allowed (after subtracting cart quantity)
                    message = `The maximum quantity per variant is ${totalCap}. You already have ${cartQty} in cart. You can add up to ${max} more.`;
                } else {
                    message = `The maximum quantity per variant is ${totalCap}.`;
                }
            } else {
                message = `You can't add more of this item.`;
            }
        }

        this.input.setCustomValidity(message);

        if (message && errorWrapper && errorMessage) {
            errorMessage.textContent = message;
            errorWrapper.hidden = false;
            errorMessage.hidden = false;

            if (submitButton) submitButton.disabled = true;

            setTimeout(() => {
                errorWrapper.hidden = true;
                errorMessage.hidden = true;
                this.input.value = max;
                if (submitButton) submitButton.disabled = false;
                this.validateQtyRules();
            }, 1500);
        } else if (errorWrapper) {
            errorWrapper.hidden = true;
            if (errorMessage) errorMessage.hidden = true;
            if (submitButton) submitButton.disabled = false;
        }

        this.validateQtyRules();
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const buttonMinus = this.querySelector('button[name="minus"]');
            if (buttonMinus) buttonMinus.toggleAttribute('disabled', value <= parseInt(this.input.min));
        }
        if (this.input.max) {
            const buttonPlus = this.querySelector('button[name="plus"]');
            if (buttonPlus) buttonPlus.toggleAttribute('disabled', value >= parseInt(this.input.max));
        }
    }

    updateQuantityRules({data: {sectionId, productId, parsedHTML}}) {
        if (sectionId !== this.sectionId || productId !== this.productId) return;

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
        const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
        // Bundle PDPs render their quantity-input without the QuantityForm
        // wrapper — pubsub has no error isolation, so throwing here killed
        // the publisher (product-info's variant sync) mid-render.
        if (!quantityForm || !quantityFormUpdated) return;
        for (let selector of selectors) {
            const current = quantityForm.querySelector(selector);
            const updated = quantityFormUpdated.querySelector(selector);
            if (!current || !updated) continue;

            if (selector === '.quantity__input') {
                const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
                for (let attribute of attributes) {
                    const valueUpdated = updated.getAttribute(attribute);
                    if (valueUpdated !== null) {
                        current.setAttribute(attribute, valueUpdated);
                    } else {
                        current.removeAttribute(attribute);
                    }
                }
            } else {
                current.innerHTML = updated.innerHTML;
            }
        }
    }

    setQuantityBoundries({data: {sectionId, productId}}) {
        if (sectionId !== this.sectionId || productId !== this.productId) return;
        const data = {
            cartQuantity: this.input.hasAttribute('data-cart-quantity')
                ? parseInt(this.input.getAttribute('data-cart-quantity'))
                : 0,
            min: this.input.hasAttribute('data-min') ? parseInt(this.input.getAttribute('data-min')) : 1,
            max: this.input.hasAttribute('data-max') ? parseInt(this.input.getAttribute('data-max')) : null,
            step: this.input.hasAttribute('step') ? parseInt(this.input.getAttribute('step')) : 1,
        };

        const productForm = this.closest('.product-form');
        const submitButton = productForm?.querySelector('[name="add"]');

        if (data.max !== null && data.cartQuantity >= data.max) {
            this.input.value = data.max;
            this.input.min = data.max;
            if (submitButton) submitButton.disabled = true;
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, undefined);
            return;
        } else {
            if (submitButton) submitButton.disabled = false;
        }

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;

        if (max) {
            this.input.max = max;
        } else {
            this.input.removeAttribute('max');
        }
        this.input.value = min;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
}

customElements.define('quantity-input', QuantityInput);

// Ensure minus/plus buttons enable/disable correctly when value changes programmatically
(function () {
    function validateWithinQuantityInput(root) {
        const quantityInputEl = root.closest('quantity-input');
        if (!quantityInputEl || !quantityInputEl.validateQtyRules) return;
        try {
            quantityInputEl.validateQtyRules();
        } catch (e) {
        }
    }

    document.addEventListener('input', function (e) {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
        if (!target.classList?.contains('quantity__input')) return;
        validateWithinQuantityInput(target);
    }, true);

    document.addEventListener('change', function (e) {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
        if (!target.classList?.contains('quantity__input')) return;
        validateWithinQuantityInput(target);
    }, true);
})();

class QuantitySelector extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.abortController = new AbortController();

        this.input = this.querySelector('input');
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.changeEvent = new Event('change', {bubbles: true});

        this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)), {
            signal: this.abortController.signal,
        });
    }

    disconnectedCallback() {
        this.abortController.abort();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.currentTarget.name === 'plus') {
            this.input.quantity = this.input.quantity + 1;
        } else {
            this.input.quantity = this.input.quantity - 1;
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-selector', QuantitySelector);

const onYouTubeApiLoaded = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = () => resolve();
});

class VideoElement extends HTMLElement {
    constructor() {
        super();

        if (this.posterElement) {
            const button = this.posterElement
            this.posterElement.addEventListener('click', this.handlePosterClick.bind(this));
        }

        // Add mute button functionality
        const muteButton = this.querySelector('[data-mute-button]');
        if (muteButton) {
            muteButton.addEventListener('click', this.handleMuteClick.bind(this));
        }

        // Add PDP play button functionality
        const pdpPlayButton = this.querySelector('.hero-play-button-pdp');
        if (pdpPlayButton) {
            pdpPlayButton.addEventListener('click', this.handlePdpPlayClick.bind(this));
        }

        // Check if this video should be unmuted by default
        if (this.hasAttribute('data-default-unmuted')) {
            this.muted = false;
        } else {
            // Initialize mute state to true by default for other videos
            this.muted = true;
        }
        this.updateMuteIcon(this.muted);

        if (this.autoplay) {
            FoxTheme.Motion.inView(this, () => {
                if (!this.paused) {
                    this.play();
                }

                return () => {
                    this.pause();
                };
            });
        }
    }

    get posterElement() {
        return this.querySelector('[id^="DeferredPoster-"]');
    }

    get controlledElement() {
        return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
    }

    get autoplay() {
        return this.hasAttribute('autoplay');
    }

    get playing() {
        return this.hasAttribute('playing');
    }

    get player() {
        return (this.playerProxy =
            this.playerProxy ||
            new Proxy(this.initializePlayer(), {
                get: (target, prop) => {
                    return async () => {
                        target = await target;
                        // Store the current mute state before any action
                        const wasMuted = this.muted;
                        await this.handlePlayerAction(target, prop);
                        // Restore mute state after action if it was changed
                        if (wasMuted !== this.muted && prop !== 'mute' && prop !== 'unmute') {
                            await this.handlePlayerAction(target, wasMuted ? 'mute' : 'unmute');
                        }
                    };
                },
            }));
    }

    static get observedAttributes() {
        return ['playing'];
    }

    handlePosterClick(event ) {
        if(event.currentTarget.hasAttribute("open-modal")){
            const modalMain = document.querySelector('#feature-popup');
            if (Shopify.designMode) {
                modalMain.setAttribute('inert','')
                modalMain.setAttribute('hidden','')
                modalMain.removeAttribute('active')
                modalMain.removeAttribute('open', '')
                return false;
            }
            const feature_id = Number(event.currentTarget.getAttribute('feature-id'));
            document.querySelectorAll(".product-features__items .f-column").forEach((singleFeatureVideo) => {
                const realIndex = Number(singleFeatureVideo.getAttribute('data-index'));
                if(feature_id === realIndex) {

                    const modalContainer = document.querySelector('#feature-popup .feature-popup__content');

                    const videoTemplate = singleFeatureVideo.querySelector('video-element template');
                    const videoSource = videoTemplate?.content.querySelector('source')?.src;

                    const headingElement = singleFeatureVideo.querySelector('.product-feature__heading');
                    const descriptionElement = singleFeatureVideo.querySelector('.product-feature__text');
                    const headingText = headingElement?.textContent?.trim();
                    const descriptionText = descriptionElement?.textContent?.trim();
                    const modalHeading = modalMain.querySelector('.feature-popup__title h3');
                    const descriptionHeading = modalMain.querySelector('.feature-popup__text');

                    if (videoSource && modalContainer) {
                        const existingVideo = modalContainer.querySelectorAll('.feature-popup__video');
                        existingVideo.forEach(video => {
                            if(video) video.remove();
                        })
                        const videoHTML = `
                            <div class="feature-popup__video">
                              <video controls autoplay playsinline controlsList="nodownload">
                                <source src="${videoSource}" type="video/mp4">
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          `;
                        modalContainer.insertAdjacentHTML('beforeend', videoHTML);
                    }

                    if (headingText && modalHeading) {
                        modalHeading.textContent = headingText;
                    }
                    if (descriptionHeading && modalHeading) {
                        descriptionHeading.textContent = descriptionText;
                    }
                    modalMain.removeAttribute('inert')
                    modalMain.removeAttribute('hidden')

                    modalMain.setAttribute('active', '')
                    modalMain.setAttribute('open', '')
                }
            })
            const modalContent = document.querySelector('#feature-popup .feature-popup__content');
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    //if esc key was not pressed in combination with ctrl or alt or shift
                    const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
                    if (isNotCombinedKey && modalContent) {
                        modalMain.setAttribute('hidden','')
                        modalContent.innerHTML = '';

                    }
                }
            });
            document.querySelector('#feature-popup .drawer__close-btn').addEventListener('click', (event) => {
                setTimeout(() => {
                    if (modalContent){
                        modalMain.setAttribute('hidden','')
                        modalContent.innerHTML = '';
                    }
                },100)
            })
            document.querySelector('#feature-popup .fixed-overlay')?.addEventListener('click', () => {
                setTimeout(() => {
                    if (modalContent){
                        modalMain.setAttribute('hidden','')
                        modalContent.innerHTML = '';
                    }
                },100)
            });
        }else{
            event.preventDefault();
            event.stopPropagation();
            if (this.playing) {
                this.paused = true;
                this.pause();
            } else {
                this.paused = false;
                this.play();
            }
        }

    }

    handlePdpPlayClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.playing) {
            this.paused = true;
            this.pause();
        } else {
            this.paused = false;
            this.play();
        }
    }

    handleMuteClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const muteButton = event.currentTarget;
        const muteIcon = muteButton.querySelector('.hero-mute-button__icon');

        if (!muteButton || !muteIcon) return;

        // Toggle the mute state
        this.muted = !this.muted;

        // Update the mute icon based on the new state
        this.updateMuteIcon(this.muted);

        // Handle mute state based on video source
        if (this.getAttribute('source') === 'youtube') {
            // Get the iframe directly and use the contentWindow to send message
            const iframe = this.querySelector('iframe');
            if (iframe && iframe.contentWindow) {
                if (this.muted) {
                    iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                } else {
                    iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
                }
            }

            // Also update the player when it's available
            if (this.player) {
                this.player.then(player => {
                    if (this.muted) {
                        player.mute();
                    } else {
                        player.unMute();
                    }
                });
            }
        } else if (this.getAttribute('source') === 'vimeo') {
            // Get the iframe directly and use the Vimeo API to set volume immediately
            const iframe = this.querySelector('iframe');
            if (iframe && window.Vimeo && window.Vimeo.Player) {
                const player = new Vimeo.Player(iframe);
                player.setVolume(this.muted ? 0 : 1);
            }

            // Also update the player when it's available
            if (this.player) {
                this.player.then(player => {
                    player.setVolume(this.muted ? 0 : 1);
                });
            }
        } else {
            // For HTML5 video, directly set the muted property
            const video = this.querySelector('video');
            if (video) {
                video.muted = this.muted;
            }
        }
    }

    updateMuteIcon(isMuted) {
        const muteIcon = this.querySelector('.hero-mute-button__icon');
        if (muteIcon) {
            muteIcon.innerHTML = isMuted ?
                '<svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.39102 20.8959C4.32152 19.1134 4.32152 16.8866 5.39102 15.1041V15.1041C5.71739 14.5601 6.25808 14.1791 6.8801 14.0547L9.41965 13.5468C9.57094 13.5165 9.70732 13.4354 9.8061 13.3168L12.9097 9.59248C14.6836 7.46388 15.5705 6.39958 16.362 6.68614C17.1535 6.9727 17.1535 8.35811 17.1535 11.1289L17.1535 24.8711C17.1535 27.6419 17.1535 29.0273 16.362 29.3139C15.5705 29.6004 14.6836 28.5361 12.9097 26.4075L9.8061 22.6832C9.70732 22.5646 9.57094 22.4835 9.41965 22.4532L6.8801 21.9453C6.25808 21.8209 5.71739 21.4399 5.39102 20.8959V20.8959Z" stroke="currentColor" stroke-width="2.5"/><path d="M23.1535 22.5L32.1535 13.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/><path d="M32.1534 22.5L23.1534 13.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>' :
                '<svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.39102 20.8959C4.32152 19.1134 4.32152 16.8866 5.39102 15.1041V15.1041C5.71739 14.5601 6.25808 14.1791 6.8801 14.0547L9.41965 13.5468C9.57094 13.5165 9.70732 13.4354 9.8061 13.3168L12.9097 9.59248C14.6836 7.46388 15.5705 6.39958 16.362 6.68614C17.1535 6.9727 17.1535 8.35811 17.1535 11.1289L17.1535 24.8711C17.1535 27.6419 17.1535 29.0273 16.362 29.3139C15.5705 29.6004 14.6836 28.5361 12.9097 26.4075L9.8061 22.6832C9.70732 22.5646 9.57094 22.4835 9.41965 22.4532L6.8801 21.9453C6.25808 21.8209 5.71739 21.4399 5.39102 20.8959V20.8959Z" stroke="currentColor" stroke-width="2.5"/></svg>';
        }
    }

    handlePlayerAction(target, prop) {
        if (this.getAttribute('source') === 'youtube') {
            if (prop === 'play') {
                target.playVideo();
                // Apply the current mute state
                if (this.muted) {
                    target.mute();
                } else {
                    target.unMute();
                }
            } else if (prop === 'pause') {
                target.pauseVideo();
            } else if (prop === 'mute') {
                target.mute();
                this.muted = true;
                this.updateMuteIcon(true);
            } else if (prop === 'unmute') {
                target.unMute();
                this.muted = false;
                this.updateMuteIcon(false);
            }
        } else if (this.getAttribute('source') === 'vimeo') {
            if (prop === 'play') {
                target.play();
                // Apply the current mute state
                target.setVolume(this.muted ? 0 : 1);
            } else if (prop === 'pause') {
                target.pause();
            } else if (prop === 'mute') {
                target.setVolume(0);
                this.muted = true;
                this.updateMuteIcon(true);
            } else if (prop === 'unmute') {
                target.setVolume(1);
                this.muted = false;
                this.updateMuteIcon(false);
            }
        } else {
            if (prop === 'play' && !this.hasAttribute('source')) {
                target.play().catch((error) => {
                    if (error.name === 'NotAllowedError') {
                        this.setAttribute('suspended', '');
                        target.controls = true;
                        const replacementImageSrc = target.previousElementSibling?.currentSrc;
                        if (replacementImageSrc) {
                            target.poster = replacementImageSrc;
                        }
                    }
                });
                // Apply the current mute state
                target.muted = this.muted;
            } else if (prop === 'pause') {
                target.pause();
            } else if (prop === 'mute') {
                target.muted = true;
                this.muted = true;
                this.updateMuteIcon(true);
            } else if (prop === 'unmute') {
                target.muted = false;
                this.muted = false;
                this.updateMuteIcon(false);
            } else {
                target[prop]();
            }
        }
    }

    play() {
        if (!this.playing) {
            this.player.play();
        }
    }

    pause() {
        if (this.playing) {
            this.player.pause();
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'playing') {
            if (oldValue === null && newValue === '') {
                // Don't hide play button when video starts playing
                return this.dispatchEvent(new CustomEvent('video:play', {bubbles: true}));
            }

            if (newValue === null) {
                // Show play button when video is paused
                const posterButton = this.querySelector('.media__poster');
                if (posterButton) {
                    posterButton.style.display = '';
                }
                return this.dispatchEvent(new CustomEvent('video:pause', {bubbles: true}));
            }
        }
    }

    initializePlayer() {
        if (this.hasAttribute('source')) {
            this.setAttribute('loaded', '');
            this.closest('.media')?.classList.remove('loading');

            return new Promise(async (resolve) => {
                const templateElement = this.querySelector('template');
                if (templateElement) {
                    templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
                }
                const script = document.createElement('script');
                script.type = 'text/javascript';
                if (this.getAttribute('source') === 'youtube') {
                    if (!window.YT || !window.YT.Player) {
                        script.src = 'https://www.youtube.com/iframe_api';
                        document.head.appendChild(script);
                        await new Promise((resolve2) => {
                            script.onload = resolve2;
                        });
                    }
                    await onYouTubeApiLoaded;
                    const player = new YT.Player(this.querySelector('iframe'), {
                        events: {
                            onReady: () => {
                                // Apply the current mute state
                                if (this.muted) {
                                    player.mute();
                                } else {
                                    player.unMute();
                                }
                                this.updateMuteIcon(this.muted);
                                resolve(player);
                            },
                            onStateChange: (event) => {
                                if (event.data === YT.PlayerState.PLAYING) {
                                    this.setAttribute('playing', '');
                                    // Apply the current mute state
                                    if (this.muted) {
                                        player.mute();
                                    } else {
                                        player.unMute();
                                    }
                                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                                    this.removeAttribute('playing');
                                }
                            },
                        },
                    });
                }
                if (this.getAttribute('source') === 'vimeo') {
                    if (!window.Vimeo || !window.Vimeo.Player) {
                        script.src = 'https://player.vimeo.com/api/player.js';
                        document.head.appendChild(script);
                        await new Promise((resolve2) => {
                            script.onload = resolve2;
                        });
                    }
                    const player = new Vimeo.Player(this.querySelector('iframe'));

                    // Apply the current mute state
                    player.setVolume(this.muted ? 0 : 1);
                    this.updateMuteIcon(this.muted);

                    // Add event listeners for play/pause
                    player.on('play', () => {
                        this.setAttribute('playing', '');
                        // Apply the current mute state
                        player.setVolume(this.muted ? 0 : 1);
                    });

                    player.on('pause', () => {
                        this.removeAttribute('playing');
                    });

                    player.on('ended', () => {
                        this.removeAttribute('playing');
                    });

                    // Also listen for volume changes
                    player.on('volumechange', event => {
                        // Update muted state based on volume
                        const newMutedState = event.volume === 0;
                        if (this.muted !== newMutedState) {
                            this.muted = newMutedState;
                            this.updateMuteIcon(this.muted);
                        }
                    });

                    resolve(player);
                }
            });
        } else {
            const templateElement = this.querySelector('template');
            if (templateElement) {
                templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
            }
            this.setAttribute('loaded', '');
            this.closest('.media')?.classList.remove('loading');

            const player = this.querySelector('video');
            // Apply the current mute state
            player.muted = this.muted;
            this.updateMuteIcon(this.muted);

            player.addEventListener('play', () => {
                this.setAttribute('playing', '');
                this.removeAttribute('suspended');
                // Apply the current mute state
                player.muted = this.muted;
            });

            // Listen for volume changes
            player.addEventListener('volumechange', () => {
                if (this.muted !== player.muted) {
                    this.muted = player.muted;
                    this.updateMuteIcon(this.muted);
                }
            });

            player.addEventListener('pause', () => {
                if (!player.seeking && player.paused) {
                    this.removeAttribute('playing');
                }
            });
            return player;
        }
    }
}

customElements.define('video-element', VideoElement);

class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
            button: this.querySelector('button'),
            panel: this.querySelector('.disclosure-list'),
        };

        this.elements.panel.removeAttribute('hidden');
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

        this.handleDropdownPos();
    }

    handleDropdownPos() {
        const offsetButton = this.elements.button.getBoundingClientRect().right;
        if (window.innerWidth - offsetButton < 220) {
            this.elements.button.nextElementSibling &&
            this.elements.button.nextElementSibling.classList.add('disclosure-list__right');
        }
    }

    hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.removeAttribute('open');
    }

    onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
    }

    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }

    openSelector() {
        this.elements.button.focus();
        this.toggleAttribute('open');
        this.elements.button.setAttribute(
            'aria-expanded',
            (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
    }

    closeSelector(event) {
        const shouldClose =
            (event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON') ||
            (event.relatedTarget && !event.relatedTarget.classList.contains('disclosure-list__option'));
        if (event.relatedTarget === null || shouldClose) {
            this.hidePanel(shouldClose);
        }
    }
}

customElements.define('localization-form', LocalizationForm);

class GridList extends HTMLElement {
    constructor() {
        super();

        if (FoxTheme.config.motionReduced || this.hasAttribute('motion-reduced')) return;

        this.hideGridItems();
        FoxTheme.Motion.inView(this, this.showGridItems.bind(this), {margin: '0px 0px -50px 0px'});
    }

    get gridItems() {
        return this.querySelectorAll('.f-column');
    }

    get visibleGridItems() {
        return this.querySelectorAll('.f-column:not([style])');
    }

    hideGridItems() {
        FoxTheme.Motion.animate(
            this.gridItems,
            {transform: 'translateY(3.5rem)', opacity: 0.01, visibility: 'hidden'},
            {duration: 0}
        );
    }

    showGridItems() {
        FoxTheme.Motion.animate(
            this.gridItems,
            {transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible']},
            {
                duration: 0.5,
                delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1),
                easing: [0, 0, 0.3, 1],
            }
        );
    }

    reShowVisibleGridItems() {
        FoxTheme.Motion.animate(
            this.visibleGridItems,
            {transform: ['translateY(3.5rem)', 'translateY(0)'], opacity: [0.01, 1], visibility: ['hidden', 'visible']},
            {
                duration: 0.5,
                delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1),
                easing: [0, 0, 0.3, 1]
            }
        );
    }
}

customElements.define('grid-list', GridList);

class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');

        FoxTheme.Motion.inView(this, this.initializeCarousel.bind(this), {margin: '200px 0px 200px 0px'});
    }

    getNextSlideButton() {
        return this.querySelector('.swiper-button-next');
    }

    getPrevSlideButton() {
        return this.querySelector('.swiper-button-prev');
    }

    get getSlideItems() {
        return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.announcementItemsWrapper.children));
    }

    isAutoplayEnabled() {
        return this.hasAttribute('autoplay');
    }

    getAutoplaySpeed() {
        return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
    }

    initializeCarousel() {
        if (this.getSlideItems.length > 1) {
            this.carousel = new FoxTheme.Carousel(
                this,
                {
                    navigation: {
                        nextEl: this.getNextSlideButton(),
                        prevEl: this.getPrevSlideButton(),
                    },
                    loop: true,
                    autoplay: this.isAutoplayEnabled() ? {
                        delay: this.getAutoplaySpeed(),
                        pauseOnMouseEnter: true
                    } : false,
                },
                FoxTheme.Swiper.Autoplay
            );
            this.carousel && this.carousel.init();

            if (Shopify.designMode) {
                this.addEventListener('shopify:block:select', (event) => {
                    this.carousel.slider.slideToLoop(this.getSlideItems.indexOf(event.target));
                });
            }
        }
    }
}

customElements.define('announcement-bar', AnnouncementBar);

class SelectElement extends HTMLElement {
    constructor() {
        super();

        FoxTheme.Motion.inView(this, this.init.bind(this), {margin: '200px 0px 200px 0px'});

        this.select = this.querySelector('select');

        this.select && this.select.addEventListener('change', this.handleSelectChange.bind(this));
    }

    init() {
        const style = window.getComputedStyle(this);
        const value = this.select.options[this.select.selectedIndex].text;

        const text = document.createElement('span');
        text.style.fontFamily = style.fontFamily;
        text.style.fontSize = style.fontSize;
        text.style.fontWeight = style.fontWeight;
        text.style.visibility = 'hidden';
        text.style.position = 'absolute';
        text.innerHTML = value;

        document.body.appendChild(text);
        const width = text.clientWidth;

        this.style.setProperty('--width', `${width}px`);
        text.remove();
    }

    handleSelectChange() {
        this.init();
    }
}

customElements.define('select-element', SelectElement);

class ProductBundleVariantSelector extends HTMLElement {
    constructor() {
        super();

        this.cssClasses = {
            soldOut: 'f-price--sold-out',
            onSale: 'f-price--on-sale',
            noCompare: 'f-price--no-compare',
        };

        this.priceElement = this.querySelector('.f-price');
        this.variantSelect = this.querySelector('select');

        this.variantSelect && this.variantSelect.addEventListener('change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
        const variantSelect = event.target;
        const selectedVariant = variantSelect.options[variantSelect.selectedIndex];
        const compareAtPrice = parseInt(selectedVariant.dataset.compare_at_price || 0);
        const price = parseInt(selectedVariant.dataset.price || 0);
        const available = selectedVariant.dataset.available === 'true';
        const priceVaries = variantSelect.dataset.price_varies === 'true';
        const compareAtPriceVaries = variantSelect.dataset.compare_at_price_varies === 'true';

        // Remove classes
        this.priceElement.classList.remove(this.cssClasses.soldOut);
        this.priceElement.classList.remove(this.cssClasses.onSale);
        this.priceElement.classList.remove(this.cssClasses.noCompare);

        // Add classes
        if (!available) {
            this.priceElement.classList.add(this.cssClasses.soldOut);
        } else if (compareAtPrice > price && available) {
            this.priceElement.classList.add(this.cssClasses.onSale);
        }
        if (!priceVaries && compareAtPriceVaries) {
            this.priceElement.classList.add(this.cssClasses.noCompare);
        }

        // Change price
        const regularPriceElement = this.querySelector('.f-price__regular');
        regularPriceElement.querySelector('.f-price-item--regular').innerHTML = `${FoxTheme.Currency.formatMoney(
            price,
            FoxTheme.settings.moneyFormat
        )}`;

        const salePriceElement = this.querySelector('.f-price__sale');
        salePriceElement.querySelector('.f-price-item--regular').innerHTML = `<s>${FoxTheme.Currency.formatMoney(
            compareAtPrice,
            FoxTheme.settings.moneyFormat
        )}</s>`;
        salePriceElement.querySelector('.f-price-item--sale').innerHTML = `${FoxTheme.Currency.formatMoney(
            price,
            FoxTheme.settings.moneyFormat
        )}`;
    }
}

customElements.define('product-bundle-variant-selector', ProductBundleVariantSelector);

class ProductsBundle extends HTMLElement {
    constructor() {
        super();

        this.cssClasses = {
            hover: 'is-hover',
            active: 'is-active',
        };

        this.cartDrawerElement = document.querySelector('cart-drawer');
        this.addToCartButtonElement = this.querySelector('button');

        this.addToCartButtonElement &&
        this.addToCartButtonElement.addEventListener('click', this.handleButtonClick.bind(this));

        this.productBundleBlocks = this.querySelectorAll('[data-block-id]');
        this.productBundleBlocks.forEach((block) =>
            block.addEventListener('mouseenter', this.handleBlockHover.bind(this, 'enter'))
        );
        this.productBundleBlocks.forEach((block) =>
            block.addEventListener('mouseleave', this.handleBlockHover.bind(this, 'leave'))
        );
    }

    handleBlockHover(type, event) {
        if (type === 'enter') {
            this.classList.add(this.cssClasses.hover);
            this.toggleBlockActive(event.target, true);
        } else {
            this.classList.remove(this.cssClasses.hover);
            this.toggleBlockActive(null, false);
        }
    }

    toggleBlockActive(target, isActive) {
        this.productBundleBlocks.forEach((block) => {
            if (target) {
                if (block.dataset.blockId === target.dataset.blockId) {
                    block.classList.add(this.cssClasses.active);
                } else {
                    block.classList.remove(this.cssClasses.active);
                }
            } else {
                block.classList.remove(this.cssClasses.active);
            }
        });
    }

    handleButtonClick(event) {
        event.preventDefault();
        this.lastClickedElement = event.submitter || event.currentTarget;

        const productIds = this.querySelectorAll('[name="id"]');
        const items = {
            items: [...productIds]
                .map((e) => e.value)
                .map((e) => ({
                    id: e,
                    quantity: 1,
                })),
        };

        if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
            FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, {
                parameters: {
                    ...items,
                },
            });
            return;
        }

        this.showErrorMessage();
        this.toggleButtonLoading(true);

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', {bubbles: true, detail: {sections: sectionsToBundle}})
        );

        const body = JSON.stringify({
            ...items,
            sections: sectionsToBundle,
            section_url: window.pathname,
        });

        fetch(`${FoxTheme.routes.cart_add_url}`, {...FoxTheme.utils.fetchConfig('javascript'), ...{body}})
            .then((response) => response.json())
            .then(async (parsedState) => {
                if (parsedState.status) {
                    this.showErrorMessage(parsedState.description);
                    return;
                }
                if (parsedState.status === 422) {
                    document.dispatchEvent(
                        new CustomEvent('product-ajax:error', {
                            detail: {
                                errorMessage: parsedState.description,
                            },
                        })
                    );
                } else {
                    const cartJson = await (
                        await fetch(`${FoxTheme.routes.cart_url}`, {...FoxTheme.utils.fetchConfig()})
                    ).json();
                    cartJson['sections'] = parsedState['sections'];

                    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {cart: cartJson});
                    document.dispatchEvent(
                        new CustomEvent('product-ajax:added', {
                            detail: {
                                product: parsedState,
                            },
                        })
                    );
                    this.cartDrawerElement && this.cartDrawerElement.show(this.lastClickedElement);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.toggleButtonLoading(false);
            });
    }

    showErrorMessage(errorMessage = false) {
        this.errorMessageElement = this.errorMessageElement || this.querySelector('.product-form__error-message');
        if (this.errorMessageElement) {
            this.errorMessageElement.hidden = !errorMessage;

            if (errorMessage) this.errorMessageElement.textContent = errorMessage;
        } else {
            errorMessage && alert(errorMessage);
        }
    }

    toggleButtonLoading(status) {
        if (status) {
            this.addToCartButtonElement.classList.add('btn--loading');
            this.addToCartButtonElement.setAttribute('disabled', true);
        } else {
            this.addToCartButtonElement.classList.remove('btn--loading');
            this.addToCartButtonElement.removeAttribute('disabled');
        }
    }
}

customElements.define('products-bundle', ProductsBundle);

class ProductRecentlyViewed extends HTMLElement {
    constructor() {
        super();

        if (FoxTheme.config.hasLocalStorage) {
            const productId = parseInt(this.dataset.productId);
            const cookieName = 'sleektheme:recently-viewed';
            const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

            if (items.includes(productId)) {
                items.splice(items.indexOf(productId), 1);
            }

            items.unshift(productId);

            window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
        }
    }
}

customElements.define('product-recently-viewed', ProductRecentlyViewed);

class MotionElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        if (FoxTheme.config.motionReduced) return;
        this.preInitialize();
        FoxTheme.Motion.inView(
            this,
            async () => {
                if (!this.isInstant && this.media) await FoxTheme.utils.imageReady(this.media);
                this.initialize();
            },
            {margin: '0px 0px -50px 0px'}
        );
    }

    get isHold() {
        return this.hasAttribute('hold');
    }

    get isInstant() {
        return this.hasAttribute('data-instantly');
    }

    get mediaElements() {
        return Array.from(this.querySelectorAll('img, iframe, svg'));
    }

    get animationType() {
        return this.dataset.motion || 'fade-up';
    }

    get animationDelay() {
        return parseInt(this.dataset.motionDelay || 0) / 1000;
    }

    preInitialize() {
        if (this.isHold) return;
        switch (this.animationType) {
            case 'fade-in':
                FoxTheme.Motion.animate(this, {opacity: 0.01}, {duration: 0});
                break;

            case 'fade-up':
                FoxTheme.Motion.animate(this, {transform: 'translateY(2.5rem)', opacity: 0.01}, {duration: 0});
                break;

            case 'zoom-in':
                FoxTheme.Motion.animate(this, {transform: 'scale(0.8)'}, {duration: 0});
                break;
            case 'zoom-in-lg':
                FoxTheme.Motion.animate(this, {transform: 'scale(0)'}, {duration: 0});
                break;

            case 'zoom-out':
                FoxTheme.Motion.animate(this, {transform: 'scale(1.3)'}, {duration: 0});
                break;

            case 'zoom-out-sm':
                FoxTheme.Motion.animate(this, {transform: 'scale(1.1)'}, {duration: 0});
        }
    }

    async initialize() {
        if (this.isHold) return;

        switch (this.animationType) {
            case 'fade-in':
                await FoxTheme.Motion.animate(
                    this,
                    {opacity: 1},
                    {duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1]}
                ).finished;
                break;

            case 'fade-up':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'translateY(0)', opacity: 1},
                    {duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1]}
                ).finished;
                break;

            case 'zoom-in':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(1)'},
                    {duration: 1.3, delay: this.animationDelay, easing: [0, 0, 0.3, 1]}
                ).finished;
                break;

            case 'zoom-in-lg':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(1)'},
                    {duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1]}
                ).finished;
                break;

            case 'zoom-out':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(1)'},
                    {duration: 1.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1]}
                ).finished;
                break;

            case 'zoom-out-sm':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(1)'},
                    {duration: 1, delay: this.animationDelay, easing: [0, 0, 0.3, 1]}
                ).finished;
                break;
        }
    }

    async resetAnimation(duration) {
        switch (this.animationType) {
            case 'fade-in':
                await FoxTheme.Motion.animate(
                    this,
                    {opacity: 0},
                    {
                        duration: duration ? duration : 1.5,
                        delay: this.animationDelay,
                        easing: duration ? 'none' : [0, 0, 0.3, 1],
                    }
                ).finished;
                break;

            case 'fade-up':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'translateY(2.5rem)', opacity: 0},
                    {
                        duration: duration ? duration : 0.5,
                        delay: this.animationDelay,
                        easing: duration ? 'none' : [0, 0, 0.3, 1],
                    }
                ).finished;
                break;

            case 'zoom-in':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(0)'},
                    {
                        duration: duration ? duration : 1.3,
                        delay: this.animationDelay,
                        easing: duration ? 'none' : [0, 0, 0.3, 1],
                    }
                ).finished;
                break;

            case 'zoom-in-lg':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(0)'},
                    {
                        duration: duration ? duration : 1.3,
                        delay: this.animationDelay,
                        easing: duration ? 'none' : [0, 0, 0.3, 1],
                    }
                ).finished;
                break;

            case 'zoom-out':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(0)'},
                    {
                        duration: duration ? duration : 1.3,
                        delay: this.animationDelay,
                        easing: duration ? 'none' : [0.16, 1, 0.3, 1],
                    }
                ).finished;
                break;

            case 'zoom-out-sm':
                await FoxTheme.Motion.animate(
                    this,
                    {transform: 'scale(0)'},
                    {
                        duration: duration ? duration : 1.3,
                        delay: this.animationDelay,
                        easing: duration ? 'none' : [0.16, 1, 0.3, 1],
                    }
                ).finished;
                break;
        }
    }

    refreshAnimation() {
        this.removeAttribute('hold');
        this.preInitialize();
        setTimeout(() => {
            this.initialize();
        }, 50); // Delay a bit to make animation re init properly.
    }
}

customElements.define('motion-element', MotionElement);

class TabsComponent extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            tabHeader: '[role="tablist"]',
            tabPanels: ['[role="tabpanel"]'],
            tabNavs: ['[role="tab"]'],
            tabSelect: 'tab-selector',
        };
        this.domNodes = FoxTheme.utils.queryDomNodes(this.selectors, this);

        this.selectedIndex = 0;
        this.selectedTab = this.domNodes.tabPanels[this.selectedIndex];
        this.scrollToActiveTab = this.dataset.scrollToActiveTab === 'true';
        this.scrollOffset = 20;
        this.headerEl = document.querySelector('.header-section header[is="sticky-header"]');

        this.init();
        this.setActiveTab(0);

        this.tabChange = new CustomEvent('tabChange', {
            bubbles: true,
            detail: {selectedTab: this.selectedTab},
        });
    }

    connectedCallback() {
        this.setActiveTab(0);
    }

    init = () => {
        this.domNodes.tabNavs.forEach((tab) => {
            tab.addEventListener('click', this.onTabClick.bind(this));
        });
        this.domNodes.tabHeader && this.domNodes.tabHeader.addEventListener('keydown', this.handleKeyDown.bind(this));
        this.setAccessible();
    };

    static get observedAttributes() {
        return ['data-selected'];
    }

    get buttons() {
        return (this._buttons = this._buttons || Array.from(this.querySelectorAll('button[role="tab"]')));
    }

    getHeaderHeight() {
        let headerHeight = 0;

        if (this.headerEl) {
            const height = Math.round(this.headerEl.offsetHeight);
            if (this.headerEl.isAlwaysSticky) {
                headerHeight = height;
            } else {
                const isSticky = document.body.classList.contains(this.headerEl.classes.pinned);

                if (window.scrollY > this.offsetTop - this.scrollOffset) {
                    headerHeight = height;
                }

                if (isSticky && window.scrollY >= this.offsetTop - this.scrollOffset - height) {
                    headerHeight = height;
                }
            }
        }

        return headerHeight;
    }

    scrollToTop() {
        let offsetTop = this.offsetTop - this.scrollOffset - this.getHeaderHeight();
        window.scrollTo({top: offsetTop, behavior: 'smooth'});
    }

    onTabClick(evt) {
        evt.preventDefault();
        const currentTab = evt.currentTarget;
        const index = currentTab ? Number(currentTab.dataset.index) : 0;
        this.setActiveTab(index);

        if (this.scrollToActiveTab) {
            this.scrollToTop();
        }
    }

    setActiveTab = (tabIndex) => {
        const {tabNavs, tabPanels, tabSelect} = this.domNodes;
        if (tabIndex !== -1) {
            const newHeader = tabNavs && tabNavs[tabIndex];
            const newTab = tabPanels && tabPanels[tabIndex];
            this.setAttribute('data-selected', tabIndex);

            tabNavs.forEach((nav) => nav.setAttribute('aria-selected', false));

            newHeader && newHeader.setAttribute('aria-selected', true);

            this.selectedIndex = tabIndex;
            this.selectedTab = newTab;

            this.dispatchEvent(
                new CustomEvent('tabChange', {
                    bubbles: true,
                    detail: {selectedIndex: tabIndex, selectedTab: newTab},
                })
            );

            if (tabSelect) {
                tabSelect.querySelector('select').value = tabIndex;
            }
        }
    };

    setAccessible() {
        const {tabNavs, tabPanels} = this.domNodes;
        tabNavs.forEach((tab, index) => {
            if (tab.id) tabPanels[index].setAttribute('aria-labelledby', tab.id);
            tab.setAttribute('aria-selected', index === 0);
            tab.setAttribute('data-index', index);
            if (index !== 0) {
                // tab.setAttribute('tabindex', -1);
            }
        });
        tabPanels.forEach((panel, index) => {
            if (panel.id) tabNavs[index].setAttribute('aria-controls', panel.id);
            panel.setAttribute('tabindex', 0);
        });
    }

    handleKeyDown(e) {
        const {tabNavs} = this.domNodes;
        if (e.keyCode === 39 || e.keyCode === 37) {
            tabNavs[this.selectedIndex].setAttribute('tabindex', -1);
            if (e.keyCode === 39) {
                this.selectedIndex++;
                // If we're at the end, go to the start.
                if (this.selectedIndex >= tabNavs.length) {
                    this.selectedIndex = 0;
                }
                // Move left.
            } else if (e.keyCode === 37) {
                this.selectedIndex--;
                // If we're at the start, move to the end.
                if (this.selectedIndex < 0) {
                    this.selectedIndex = tabNavs.length - 1;
                }
            }

            tabNavs[this.selectedIndex].setAttribute('tabindex', 0);
            tabNavs[this.selectedIndex].focus();
        }
    }

    getSelected() {
        return {
            index: this.selectedIndex,
            element: this.selectedTab,
        };
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-selected' && oldValue !== null && oldValue !== newValue) {
            const fromButton = this.buttons[parseInt(oldValue)];
            const toButton = this.buttons[parseInt(newValue)];
            this.transition(
                document.getElementById(fromButton.getAttribute('aria-controls')),
                document.getElementById(toButton.getAttribute('aria-controls'))
            );
        }
    }

    async transition(fromPanel, toPanel) {
        await FoxTheme.Motion.animate(
            fromPanel,
            {transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0]},
            {duration: 0.3}
        ).finished;

        fromPanel.hidden = true;
        toPanel.hidden = false;

        FoxTheme.Motion.animate(
            toPanel,
            {transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1]},
            {duration: 0.3}
        ).finished;

        toPanel.querySelector('grid-list') && toPanel.querySelector('grid-list').showGridItems();
    }
}

customElements.define('tabs-component', TabsComponent);

class TabSelector extends HTMLElement {
    constructor() {
        super();

        this.tabs = this.closest('tabs-component');

        this.querySelector('select').addEventListener('change', (e) => {
            this.tabs.setActiveTab(e.target.value);
        });
    }
}

customElements.define('tab-selector', TabSelector);

class Parallax extends HTMLElement {
    get parallax() {
        return this.dataset.parallax ? parseFloat(this.dataset.parallax) : false;
    }

    get parallaxDirection() {
        return this.dataset.parallaxDirection || 'vertical';
    }

    get parallaxMediaElements() {
        return Array.from(this.querySelectorAll('img, video, iframe, svg, video-element'));
    }

    connectedCallback() {
        if (this.shouldInitializeParallax()) {
            this.setupParallax();
        }
    }

    shouldInitializeParallax() {
        return !FoxTheme.config.motionReduced && this.parallax;
    }

    setupParallax() {
        const parallaxScale = 1 + this.parallax;
        const parallaxTranslate = (this.parallax * 100) / (1 + this.parallax);

        let parallaxTransformProperties = {};

        if (this.parallaxDirection === 'vertical') {
            parallaxTransformProperties = {
                transform: [
                    `scale(${parallaxScale}) translateY(0)`,
                    `scale(${parallaxScale}) translateY(${parallaxTranslate}%)`,
                ],
                transformOrigin: ['bottom', 'bottom'],
            };
        } else if (this.parallaxDirection === 'horizontal') {
            parallaxTransformProperties = {
                transform: [
                    `scale(${parallaxScale}) translateX(0)`,
                    `scale(${parallaxScale}) translateX(${parallaxTranslate}%)`,
                ],
                transformOrigin: ['right', 'right'],
            };
        } else {
            parallaxTransformProperties = {
                transform: [`scale(1)`, `scale(${parallaxScale})`],
                transformOrigin: ['center', 'center'],
            };
        }

        FoxTheme.Motion.scroll(
            FoxTheme.Motion.animate(this.parallaxMediaElements, parallaxTransformProperties, {easing: 'linear'}),
            {
                target: this,
                offset: ['start end', 'end start'],
            }
        );
    }
}

customElements.define('parallax-element', Parallax);

class ProductForm extends HTMLFormElement {
    constructor() {
        super();

        this.productIdInput = this.querySelector('[name=id]');
        // TODO: CHECK THIS
        // this.productIdInput.disabled = false;
        this.addEventListener('submit', this.handleFormSubmit);
    }

    get cartDrawerElement() {
        return document.querySelector('cart-drawer');
    }

    get submitButtonElement() {
        return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]'));
    }

    get isHideErrors() {
        return this.dataset.hideErrors === 'true';
    }

  handleFormSubmit = async (event) => {
    if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType === 'page') return;

        event.preventDefault();
        if (this.submitButtonElement.hasAttribute('aria-disabled')) return;
        this.lastSubmittedElement = event.submitter || event.currentTarget;

        this.displayFormErrors();

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', {bubbles: true, detail: {sections: sectionsToBundle}})
        );

        const config = FoxTheme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        this.formData = new FormData(this);
        this.formData.append('sections', sectionsToBundle);
        this.formData.append('sections_url', window.location.pathname);

        config.body = this.formData;

        this.submitButtonElement.setAttribute('aria-disabled', 'true');
        this.submitButtonElement.classList.add('btn--loading');

    // this.handleFormSubmission(config);
    const variantId = parseInt(this.productIdInput.value);
    const quantity = parseInt(this.formData.get('quantity')) || 1;

    // Check Discount Ninja eligibility via promotion data
    const dnEligible = window.discountNinja?.Offer?.Offers?.some((offer) => {
      const entitledHandles = offer.Entitlement?.EntitledProductHandles?.split(',') || [];
      const handle = this.closest('[data-product-handle]')?.dataset?.productHandle;
      return entitledHandles.includes(handle);
    });

    if (dnEligible && window.discountNinja?.api?.cart?.add) {
      try {
        // Collect line item properties
        const properties = {};
        for (const [key, value] of this.formData.entries()) {
          if (key.startsWith('properties[')) {
            const match = key.match(/properties\[(.+?)\]/);
            if (match && match[1]) properties[match[1]] = value;
          }
        }

        await window.discountNinja.api.cart.add(variantId, quantity, properties);
        // console.log('Discount Ninja cart add');

        // Fetch the latest cart data to update the cart count
        const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, {...FoxTheme.utils.fetchConfig()})).json();
        this.updateCartState(cartJson);

        // First refresh the cart to ensure the DOM is updated
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        // console.log('Discount Ninja cart refresh');

        // Then apply strikethrough pricing after a slight delay to ensure DOM is ready
        setTimeout(async () => {
          // if (window.discountNinja?.api?.strikethroughPricing?.apply) {
          //   await window.discountNinja.api.strikethroughPricing.apply();
          //   console.log('Discount Ninja strikethrough pricing applied');
          // }

          // Trigger the cart updated event after pricing is updated
          document.dispatchEvent(new CustomEvent('la:dn:cart:updated'));
        }, 300);

        this.showCartDrawer();

        // Remove duplicate cart refresh here - it's already done above
      } catch (err) {
        console.error('❌ Discount Ninja add error', err);
        this.displayFormErrors('Something went wrong with the promotion.');
      } finally {
        this.submitButtonElement.classList.remove('btn--loading');
        this.submitButtonElement.removeAttribute('aria-disabled');
      }
    } else {
      // fallback to default Shopify add logic
      this.handleFormSubmission(config);
    }
  };


    displayFormErrors = (errorMessage = false) => {
        if (this.isHideErrors) return;

        this.formErrorMessage = this.formErrorMessage || this.querySelector('.product-form__error-message');
        if (!this.formErrorMessage) {
            if (errorMessage !== false) {
                alert(errorMessage);
            }
        } else {
            this.formErrorMessage.toggleAttribute('hidden', !errorMessage);
            this.formErrorMessage.innerText = errorMessage;
        }
    };

    handleFormSubmission = (config) => {
        fetch(`${FoxTheme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then(async (parsedState) => {
                if (parsedState.status) {
                    this.handleCartError(parsedState);
                    return;
                }

                const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, {...FoxTheme.utils.fetchConfig()})).json();
                cartJson['sections'] = parsedState['sections'];

                this.updateCartState(cartJson);
                this.dispatchProductAddedEvent(parsedState);

                this.showCartDrawer();
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                this.submitButtonElement.classList.remove('btn--loading');
                this.submitButtonElement.removeAttribute('aria-disabled');

                if (!this.hasError) {
                    this.submitButtonElement.removeAttribute('aria-disabled');
                }
            });
    };

    handleCartError = (parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: this.formData.get('id'),
            errors: parsedState.errors || parsedState.description,
            message: parsedState.message,
        });

        this.displayFormErrors(parsedState.description);
        document.dispatchEvent(
            new CustomEvent('product-ajax:error', {
                detail: {
                    errorMessage: parsedState.description,
                },
            })
        );
        this.hasError = true;
    };

    updateCartState = (cartJson) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {cart: cartJson});
    };

    dispatchProductAddedEvent = (parsedState) => {
        document.dispatchEvent(
            new CustomEvent('product-ajax:added', {
                detail: {
                    product: parsedState,
                },
            })
        );
    };

    showCartDrawer = () => {
        const quickViewModal = this.closest('quick-view-modal');
        if (quickViewModal) {
            if (this.cartDrawerElement && !this.cartDrawerElement.open) {
                document.body.addEventListener(
                    quickViewModal.events.handleAfterHide,
                    () => {
                        setTimeout(() => {
                            this.cartDrawerElement.show(this.lastSubmittedElement);
                        });
                    },
                    {once: true}
                );
            }

            quickViewModal.hide(true);
        } else {
            this.cartDrawerElement && this.cartDrawerElement.show(this.lastSubmittedElement);
        }
    };
}

customElements.define('product-form', ProductForm, {extends: 'form'});

class HighlightText extends HTMLElement {
    constructor() {
        super();

        FoxTheme.Motion.inView(this, this.init.bind(this));
    }

    init() {
        this.classList.add('animate');
    }
}

customElements.define('highlight-text', HighlightText, {extends: 'em'});

class NewsletterForm extends HTMLFormElement {
    constructor() {
        super();

        this.selectors = {
            subscribedMessage: '[id*=Newsletter-error-subscribed]',
        };

        this.init();
    }

    /**
     * Show message when user re-subscribe with exists email.
     */
    init() {
        const liveUrl = window.location.href;
        const result = liveUrl.includes('form_type=customer');
        const inputEl = this.querySelector('[id*="NewsletterForm"]');
        if (!inputEl) return;
        const inputVal = inputEl.value.length;
        const messageElement = this.querySelector(this.selectors.subscribedMessage);

        if (result && inputVal != 0 && messageElement) {
            messageElement.classList.remove('hidden');
        }
    }
}

customElements.define('newsletter-form', NewsletterForm, {extends: 'form'});

/* Yotpo widgets loader — injected dynamically so it never blocks rendering. */
(function () {
    var YOTPO_LOADER_SRC = 'https://cdn-widgetsrepository.yotpo.com/v1/loader/bMHJNNJLMLHJvJHGr0boAGlwBZvRese2paQzgRtH';
    if (document.querySelector('script[src="' + YOTPO_LOADER_SRC + '"]')) return;
    var script = document.createElement('script');
    script.src = YOTPO_LOADER_SRC;
    script.async = true;
    (document.head || document.documentElement).appendChild(script);
})();
